import React, { useMemo } from 'react';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import MuiChip from '@material-ui/core/Chip';
import makeTheme from '~/assets/styles/makePrimaryColorTheme';

const Chip = ({color, ...props}) => {
  const theme = useMemo(() => makeTheme(color));
  return <ThemeProvider theme={theme}>
    <MuiChip {...props} color='primary'/>
  </ThemeProvider>
}

export default React.memo(Chip)